<template>
      <div :class="['category-list__item',{'category-list__item--selected': this.active}]" @click="$emit('click')">
          <span>{{this.title}}</span>
      </div>
</template>

<script>
export default {
    props:{
        active: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
    }
}
</script>

<style lang="scss" scoped>
.category-list {
    &__item {
        background-color: $color-card;
        box-shadow: 0px 0px 20px #0000000F;
        white-space: nowrap;
        cursor: pointer;
        min-height: 90px;
        max-height: 90px;
        height: 100%;
        max-width: 190px;
        min-width: 190px;
        font-size: 18px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        user-select: none;

        &:not(:last-child) {
            margin-right: 30px;
        }

        &:hover {
            border-image: $gradient-nexyo;
            border-style: solid;
            border-width: 3px;
            border-image-slice: 1;
            font-weight: 500;
        }

        span{
            max-width: 100px;
            white-space: initial;
            text-align: center;
        }

        &--selected{
            background: $gradient-nexyo;
            font-weight: 500;
            color: white;
        }
    }
}
</style>